interface ConnexionDotProps {
  color: string;
  label: string;
  subLabel?: string | null;
}

const ConnexionDot = ({color, label, subLabel}: ConnexionDotProps): JSX.Element => {
  return (
    <span style={{display: 'inline-flex', alignItems: 'center', gap: 8, fontSize: 13}}>
      <span
        style={{
          width: 8,
          height: 8,
          borderRadius: '50%',
          backgroundColor: color,
          flexShrink: 0,
        }}
      />
      <span style={{display: 'inline-flex', flexDirection: 'column', lineHeight: 1.2}}>
        <span style={{color: '#3f4254', fontWeight: 500}}>{label}</span>
        {subLabel && <span style={{color: '#a1a5b7', fontSize: 11}}>{subLabel}</span>}
      </span>
    </span>
  );
};

export default ConnexionDot;
